"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpHeaderContentType = exports.HttpHeaderName = void 0;
/**
 * Http header name enum.
 * For tracking headers, used by http APIs.
 */
var HttpHeaderName;
(function (HttpHeaderName) {
    HttpHeaderName["CONTENT_TYPE"] = "Content-Type";
})(HttpHeaderName = exports.HttpHeaderName || (exports.HttpHeaderName = {}));
/**
 * Http header content type enum.
 * For tracking content types, used by application.
 */
var HttpHeaderContentType;
(function (HttpHeaderContentType) {
    HttpHeaderContentType["FORM"] = "application/x-www-form-urlencoded";
    HttpHeaderContentType["JSON"] = "application/json";
})(HttpHeaderContentType = exports.HttpHeaderContentType || (exports.HttpHeaderContentType = {}));
